export default "__VITE_ASSET__R3IcT1cS__"